import idx from "idx"

/**
 * transform - manipulate data from the graphql query
 * @param {object} ourPeople
 * @returns {object}
 */
function transform(ourPeople) {
  const people = ourPeople.map(person => {
    return {
      photo: idx(person, _ => _.gridPhoto),
      title: idx(person, _ => _.title),
      slug: idx(person, _ => _.slug),
      name: idx(person, _ => _.name)
    }
  })

  return {
    people
  }
}

export default { transform }
